import React, { Component } from 'react';
import { Dropdown, Modal, Button } from 'react-bootstrap';
import Layout from '../Components/Layout';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import PaginatedItems from "../Components/Pagination";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const badgeStyles = `
.table-container {
    overflow-y: auto !important;
    overflow-x: auto !important;
}
.table-container thead th {
    position: sticky;
    top: 0;
    z-index: 100;
    background: #f8f9fa !important;
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.1);
}
.status-dropdown {
    min-width: 160px;
}
.date-dropdown {
    min-width: 140px;
}
.dropdown-toggle::after {
    display: none !important;
}
.dropdown-menu {
    z-index: 1060 !important;
    position: absolute !important;
}
.table tbody tr:hover {
    background-color: rgba(0, 0, 0, 0.02);
}
.action-dropdown .dropdown-menu {
    position: absolute !important;
    z-index: 1070 !important;
    right: 0 !important;
    left: auto !important;
    transform: none !important;
    inset: auto 0px auto auto !important;
}
.action-dropdown {
    position: relative !important;
}
.react-datepicker-popper {
    z-index: 1080 !important;
}
.react-datepicker {
    z-index: 1080 !important;
}
`;

export class FormulaRepository extends Component {
    state = {
        records: [],
        search: "",
        statusFilter: 'r&d',
        dateFilter: 'All Dates',
        filtered: false,
        pageNumber: 1,
        totalItems: 0,
        perPage: parseInt(localStorage.getItem('formulaPerPage')) || 25,
        showDeleteModal: false,
        deleteFormulaId: null,
        loading: true,
        error: null,
        showCustomDatePicker: false,
        customStartDate: null,
        customEndDate: null,
        showHistoryModal: false,
        historyData: [],
        historyRfqId: null,
        historyPage: 1,
        historyTotalPages: 1,
        historyLoading: false,
        isAdmin: false,
        submittingFormulaId: null,
        assignableUsers: [],
        assignedToFilter: null
    }

    componentDidMount() {
        this.checkRole();
        this.getFormulas(1);
        this.fetchAssignableUsers();
    }

    fetchAssignableUsers() {
        axios.get('/rfq/assigned-to')
            .then(response => {
                this.setState({ assignableUsers: response.data.data || response.data || [] });
            })
            .catch(err => console.error('Error fetching assignable users:', err));
    }

    handleAssign = async (formulaId, userId) => {
        try {
            await axios.put(`/api/formulas/${formulaId}/assign`, {
                assigned_to: userId ? parseInt(userId) : null
            });
            toast.success('Assignment updated');
            this.getFormulas(this.state.pageNumber);
        } catch (error) {
            toast.error('Failed to update assignment');
        }
    }

    handleAssignedToFilter = (userId) => {
        this.setState({ assignedToFilter: userId, pageNumber: 1 }, () => {
            this.getFormulas(1);
        });
    }

    async checkRole() {
        try {
            const response = await axios.get('/manage/check-role');
            if (response.data === "Admin") {
                this.setState({ isAdmin: true });
            }
        } catch (error) {
            console.error('Error checking role:', error);
        }
    }


    getFormulas(pageNumber = 1) {
        let _self = this;

        // Set loading state
        _self.setState({ loading: true, error: null });

        let dataObj = {
            skip: (pageNumber - 1) * _self.state.perPage,
            limit: _self.state.perPage,
            status_filter: _self.state.statusFilter !== "All" ? _self.state.statusFilter : null,
            search: _self.state.search || null,
            assigned_to: _self.state.assignedToFilter
        }

        // Add date filter parameters
        if (_self.state.dateFilter !== "All Dates") {
            dataObj.date_filter = _self.state.dateFilter;

            // Add custom date range if selected
            if (_self.state.dateFilter === 'Custom' && _self.state.customStartDate && _self.state.customEndDate) {
                dataObj.custom_start_date = _self.state.customStartDate.toISOString().split('T')[0];
                dataObj.custom_end_date = _self.state.customEndDate.toISOString().split('T')[0];
            }
        }

        if(_self.state.search !== "" || _self.state.statusFilter !== "All" || _self.state.dateFilter !== "All Dates") {
            const filtered = true;
            _self.setState({ filtered });
        } else {
            const filtered = false;
            _self.setState({ filtered });
        }

        // Call the API to get formulas
        const params = new URLSearchParams();
        Object.keys(dataObj).forEach(key => {
            if (dataObj[key] !== null && dataObj[key] !== undefined) {
                params.append(key, dataObj[key]);
            }
        });

        axios.get(`/api/formulas?${params}`)
            .then(response => {
                console.log('API Response:', response.data);

                if (response.data && response.data.success) {
                    const formulas = response.data.data || [];
                    console.log('Formulas from API:', formulas);

                    // Transform API data to match component format
                    const records = formulas
                        .filter(formula => {
                            // Apply status filtering logic similar to RequestQuote.js
                            const isArchived = formula.is_archived === true || formula.is_archived === 1;

                            // If filtering by "All", show everything (both formulas and archived)
                            if (_self.state.statusFilter === 'All') {
                                return true;
                            }

                            // If filtering by "Archived", only show archived formulas
                            if (_self.state.statusFilter === 'Archived') {
                                return isArchived;
                            }

                            // For specific status filters, show only non-archived with that status
                            if (_self.state.statusFilter !== 'All' && _self.state.statusFilter !== 'Archived') {
                                // Map display values to actual status values
                                const statusMap = {
                                    'r&d': 'r&d',
                                };
                                const targetStatus = statusMap[_self.state.statusFilter] || _self.state.statusFilter;
                                return !isArchived && formula.status === targetStatus;
                            }

                            return true;
                        })
                        .map((formula, index) => {
                            // Format timestamps
                            let dateCreated = 'N/A';
                            if (formula.date_created) {
                                dateCreated = new Date(formula.date_created).toLocaleDateString();
                            }

                            // Check if archived (similar to RequestQuote.js)
                            const isArchived = formula.is_archived === true || formula.is_archived === 1;
                            const status = isArchived ? 'archived' : (formula.status || 'r&d');

                            // Get rfqStatus from API response (the API returns rfq_status)
                            const rfqStatus = formula.rfq_status || formula.RfqStatus || formula.rfqStatus || formula.RFQ_STATUS || null;

                            const transformedRecord = {
                                id: formula.formula_id,
                                customer: formula.customer || '—',
                                product: formula.product_name || '',
                                form: formula.form || '',
                                status: status,
                                dateCreated: dateCreated,
                                rfqStatus: rfqStatus,
                                rfqId: formula.rfq_id,
                                assignedTo: formula.assigned_to,
                                assignedToName: formula.assigned_to_name || ''
                            };

                            return transformedRecord;
                        });

                    console.log('All transformed records:', records);

                    _self.setState({
                        records,
                        totalItems: response.data.total || 0,
                        loading: false,
                        error: null
                    });
                } else {
                    console.log('API returned success: false or no response.data');
                    console.log('Full response:', response);
                    _self.setState({
                        records: [],
                        totalItems: 0,
                        loading: false,
                        error: 'Failed to load formulas'
                    });
                }
            }).catch(error => {
            console.error('There was an error fetching formulas!', error);
            _self.setState({
                records: [],
                totalItems: 0,
                loading: false,
                error: 'Error fetching formulas'
            });
        });
    }

    onSearchClick(e) {
        this.setState({ pageNumber: 1 }, () => {
            this.getFormulas(1);
        });
    }

    onSearch(e) {
        const search = e.target.value;
        this.setState({ search });
        if (this.searchTimeout) clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            this.setState({ pageNumber: 1 }, () => {
                this.getFormulas(1);
            });
        }, 300);
    }

    componentWillUnmount() {
        if (this.searchTimeout) clearTimeout(this.searchTimeout);
    }

    onKeyUp(e) {
        if (e.charCode === 13) {
            this.onSearchClick(e);
        }
    }

    handleStatusFilter = (status) => {
        this.setState({ statusFilter: status, pageNumber: 1 }, () => {
            this.getFormulas(1);
        });
    }

    handleDateFilter = (dateFilter) => {
        if (dateFilter === 'Custom') {
            this.setState({ dateFilter, showCustomDatePicker: true });
        } else {
            this.setState({ dateFilter, pageNumber: 1, showCustomDatePicker: false }, () => {
                this.getFormulas(1);
            });
        }
    }

    handleCustomDateApply = () => {
        if (this.state.customStartDate && this.state.customEndDate) {
            this.setState({ showCustomDatePicker: false, pageNumber: 1 }, () => {
                this.getFormulas(1);
            });
        } else {
            toast.error('Please select both start and end dates');
        }
    }

    handleCustomDateCancel = () => {
        this.setState({
            showCustomDatePicker: false,
            dateFilter: 'All Dates',
            customStartDate: null,
            customEndDate: null
        });
    }

    openPage(e, formulaId) {
        e.preventDefault();
        // Extract numeric part from formula ID (e.g., "FORM-0006" -> "6")
        const numericId = formulaId.replace(/^FORM-0*/, '');
        window.location.href = "/formula/edit?id=" + numericId;
    }

    onAddClick(e) {
        e.preventDefault();
        window.location.href = "/formula/new";
    }

    paginatePage = (page) => {
        const pageNumber = page
        this.setState({ pageNumber });
        this.getFormulas(page);
    }

    onPerPageChange(e) {
        const perPage = parseInt(e.target.value);
        localStorage.setItem('formulaPerPage', perPage);
        this.setState({ perPage, pageNumber: 1 }, () => {
            this.getFormulas(1);
        });
    }

    handleAction = (action, formulaId) => {
        switch(action) {
            case 'edit':
                this.openPage({ preventDefault: () => {} }, formulaId);
                break;
            case 'history':
                this.showFormulaHistory(formulaId);
                break;
            case 'archive':
                this.archiveFormula(formulaId);
                break;
            case 'unarchive':
                this.unarchiveFormula(formulaId);
                break;
            case 'submitToDraftQuote':
                this.submitToEstimate(formulaId);
                break;
            case 'delete':
                this.setState({ showDeleteModal: true, deleteFormulaId: formulaId });
                break;
            default:
                break;
        }
    }

    showFormulaHistory = (formulaId) => {
        // Extract numeric ID from formatted ID
        const numericId = parseInt(formulaId.replace('FORM-', ''));
        this.openHistoryModal(numericId);
    }

    openHistoryModal = (rfqId) => {
        this.setState({
            showHistoryModal: true,
            historyRfqId: rfqId,
            historyPage: 1
        }, () => {
            this.fetchHistory(1);
        });
    }

    closeHistoryModal = () => {
        this.setState({
            showHistoryModal: false,
            historyData: [],
            historyRfqId: null,
            historyPage: 1
        });
    }

    fetchHistory = async (page) => {
        const { historyRfqId } = this.state;
        this.setState({ historyLoading: true });

        try {
            const response = await axios.get(`/rfq/${historyRfqId}/history`, {
                params: { page, per_page: 10 }
            });

            if (response.data.success) {
                this.setState({
                    historyData: response.data.data,
                    historyPage: page,
                    historyTotalPages: response.data.pagination.totalPages,
                    historyLoading: false
                });
            }
        } catch (error) {
            console.error('Error fetching history:', error);
            toast.error('Failed to load history');
            this.setState({ historyLoading: false });
        }
    }

    handleHistoryPageChange = (newPage) => {
        this.fetchHistory(newPage);
    }

    viewHistoryRecord = (e, history) => {
        e.preventDefault();
        if(history.statusNumber == 1)
        {
            window.location.href = "/request-quote/view?historyId=" + history.rfqHistoryId;
        }
        else if(history.statusNumber == 2)
        {
            window.location.href = "/formula/view?historyId=" + history.rfqHistoryId;
        }
        else if(history.statusNumber >= 3 && history.statusNumber <= 6)
        {
           window.location.href = "/draft-estimate/view?historyId=" + history.rfqHistoryId;
        }
    }

    submitToEstimate = async (formulaId) => {
        if (this.state.submittingFormulaId) return;
        this.setState({ submittingFormulaId: formulaId });

        try {
            await axios.post(`/api/formulas/${formulaId}/submit-to-draft-estimate`);
            toast.success(`${formulaId} submitted to Estimate successfully`);
            window.location.href = "/draft-estimate";
        } catch (error) {
            if (error.response?.status === 409) {
                toast.warn('This formula has already been submitted to Estimate.');
                window.location.href = "/draft-estimate";
            } else {
                console.error('Error submitting formula to Estimate:', error);
                toast.error(`Failed to submit ${formulaId} to Estimate`);
            }
            this.setState({ submittingFormulaId: null });
        }
    }

    archiveFormula = async (formulaId) => {
        try {
            await axios.put(`/api/formulas/${formulaId}/archive`);
            toast.success(`${formulaId} archived successfully`);
            this.getFormulas(this.state.pageNumber);
        } catch (error) {
            console.error('Error archiving formula:', error);
            toast.error(`Failed to archive ${formulaId}`);
        }
    }

    unarchiveFormula = async (formulaId) => {
        try {
            await axios.put(`/api/formulas/${formulaId}/unarchive`);
            toast.success(`${formulaId} unarchived successfully`);
            this.getFormulas(this.state.pageNumber);
        } catch (error) {
            console.error('Error unarchiving formula:', error);
            toast.error(`Failed to unarchive ${formulaId}`);
        }
    }

    confirmDelete = async () => {
        const { deleteFormulaId } = this.state;
        try {
            // Extract numeric ID from formula ID (e.g., "FORM-0006" -> "6")
            const numericId = deleteFormulaId.replace(/^FORM-0*/, '');

            await axios.delete(`/rfq/${numericId}`);

            // Refresh the list after successful deletion
            this.getFormulas(this.state.pageNumber);

            this.setState({
                showDeleteModal: false,
                deleteFormulaId: null
            });
            toast.success(`${deleteFormulaId} deleted successfully`);
        } catch (error) {
            console.error('Error deleting formula:', error);
            toast.error(`Failed to delete ${deleteFormulaId}`);
        }
    }

    handleCloseDeleteModal = () => {
        this.setState({ showDeleteModal: false, deleteFormulaId: null });
    }

    getStatusBadge = (status) => {
        const badgeStyles = {
            'in-process': { backgroundColor: '#28a745', color: 'white' },
            'draft': { backgroundColor: '#6c757d', color: 'white' },
            'archived': { backgroundColor: '#dc3545', color: 'white' },
        };

        const displayText = {
            'in-process': 'in-process',
            'draft': 'draft',
            'archived': 'archived',
        };

        return (
            <span
                style={{
                    ...badgeStyles[status],
                    padding: '4px 12px',
                    borderRadius: '20px',
                    fontSize: '12px',
                    fontWeight: '500',
                }}
            >
                {displayText[status] || status}
            </span>
        );
    };

    render() {
        const { records, search, statusFilter, dateFilter, pageNumber, totalItems, perPage, showDeleteModal, deleteFormulaId, loading, error, showCustomDatePicker, customStartDate, customEndDate } = this.state;


        return (
            <Layout>
                <style>{badgeStyles}</style>
                <div style={{ height: 'calc(100vh - 70px)', display: 'flex', flexDirection: 'column', paddingTop: '20px', overflow: 'hidden' }}>
                    <section className="section pb-0" style={{ marginBottom: '0px', paddingTop: '20px', paddingBottom: '0px', flex: '1', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
                        <div className="container-fluid" style={{ paddingLeft: '24px', flex: '1', display: 'flex', flexDirection: 'column', minHeight: 0 }}>

                            {/* Header Section */}
                            <div className="d-flex justify-content-between align-items-center mb-3" style={{ flexShrink: 0 }}>
                                <div>
                                    <p style={{ color: '#6b7280', fontSize: '16px', margin: 0 }}>Manage and track all product formulations</p>
                                </div>
                                {/* "Add New Formula" removed — formulas are created via RFQ submission to prevent duplicates */}
                                <div className="d-flex" style={{ gap: '10px' }}>
                                </div>
                            </div>

                            {/* Filters Section */}
                            <div className="row" style={{'@media print': {display: 'none'}, flexShrink: 0}}>
                                <div className="col-lg-12 mb-3">
                                    <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #e5e7eb', padding: '24px', marginBottom: '20px' }}>
                                        <h5 style={{ fontWeight: '600', marginBottom: '16px' }}>Filters & Search</h5>
                                        <div className="row">
                                            <div className="col-lg-4 mb-3">
                                                <div className="input-group">
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        onKeyPress={(e) => this.onKeyUp(e)}
                                                        onChange={(e) => this.onSearch(e)}
                                                        placeholder="Search by formula number, customer, or product..."
                                                        value={search}
                                                        style={{padding: '12px'}}
                                                        aria-describedby="basic-addon2"
                                                    />
                                                    <div className="input-group-append">
                                                        <span onClick={(e) => this.onSearchClick(e)} className="input-group-text ti-search" id="basic-addon2" style={{cursor: 'pointer'}}></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-2 mb-3">
                                                <Dropdown className="w-100">
                                                    <Dropdown.Toggle variant="outline-secondary" className="w-100 text-start d-flex justify-content-between align-items-center">
                                                        {this.state.assignedToFilter === null ? 'All Assigned' :
                                                         this.state.assignedToFilter === 0 ? 'Unassigned' :
                                                         (this.state.assignableUsers.find(u => u.id === this.state.assignedToFilter)?.fullname || 'Assigned')}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className="w-100">
                                                        <Dropdown.Item
                                                            onClick={() => this.handleAssignedToFilter(null)}
                                                            active={this.state.assignedToFilter === null}
                                                        >
                                                            All Assigned
                                                        </Dropdown.Item>
                                                        <Dropdown.Item
                                                            onClick={() => this.handleAssignedToFilter(0)}
                                                            active={this.state.assignedToFilter === 0}
                                                        >
                                                            Unassigned
                                                        </Dropdown.Item>
                                                        <Dropdown.Divider />
                                                        {this.state.assignableUsers.map(u => (
                                                            <Dropdown.Item
                                                                key={u.id}
                                                                onClick={() => this.handleAssignedToFilter(u.id)}
                                                                active={this.state.assignedToFilter === u.id}
                                                            >
                                                                {u.fullname}
                                                            </Dropdown.Item>
                                                        ))}
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                            <div className="col-lg-3 mb-3">
                                                <Dropdown className="w-100">
                                                    <Dropdown.Toggle variant="outline-secondary" className="w-100 text-start d-flex justify-content-between align-items-center status-dropdown">
                                                        {statusFilter === 'r&d' ? 'R&D' : statusFilter}
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className="w-100">
                                                        <Dropdown.Item
                                                            onClick={() => this.handleStatusFilter('All')}
                                                            active={statusFilter === 'All'}
                                                        >
                                                            {statusFilter === 'All' && <i className="ti-check me-2"></i>}
                                                            All
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => this.handleStatusFilter('r&d')}>
                                                            {statusFilter === 'r&d' && <i className="ti-check me-2"></i>}
                                                            R&D
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => this.handleStatusFilter('Archived')}>
                                                            {statusFilter === 'Archived' && <i className="ti-check me-2"></i>}
                                                            Archived
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                            <div className="col-lg-3 mb-3">
                                                <Dropdown className="w-100">
                                                    <Dropdown.Toggle variant="outline-secondary" className="w-100 text-start d-flex justify-content-between align-items-center date-dropdown">
                                                        {dateFilter === 'Custom' && this.state.customStartDate && this.state.customEndDate ?
                                                            `${this.state.customStartDate.toLocaleDateString()} - ${this.state.customEndDate.toLocaleDateString()}` :
                                                            dateFilter
                                                        }
                                                    </Dropdown.Toggle>
                                                    <Dropdown.Menu className="w-100">
                                                        <Dropdown.Item
                                                            onClick={() => this.handleDateFilter('All Dates')}
                                                            active={dateFilter === 'All Dates'}
                                                        >
                                                            {dateFilter === 'All Dates' && <i className="ti-check me-2"></i>}
                                                            All Dates
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => this.handleDateFilter('Today')}>
                                                            {dateFilter === 'Today' && <i className="ti-check me-2"></i>}
                                                            Today
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => this.handleDateFilter('This Week')}>
                                                            {dateFilter === 'This Week' && <i className="ti-check me-2"></i>}
                                                            This Week
                                                        </Dropdown.Item>
                                                        <Dropdown.Item onClick={() => this.handleDateFilter('This Month')}>
                                                            {dateFilter === 'This Month' && <i className="ti-check me-2"></i>}
                                                            This Month
                                                        </Dropdown.Item>
                                                        <Dropdown.Divider />
                                                        <Dropdown.Item onClick={() => this.handleDateFilter('Custom')}>
                                                            {dateFilter === 'Custom' && <i className="ti-check me-2"></i>}
                                                            Custom Date Range
                                                        </Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Formula List Section */}
                            <div style={{ background: 'white', borderRadius: '12px', border: '1px solid #e5e7eb', display: 'flex', flexDirection: 'column', flex: '1', minHeight: 0, marginBottom:'10px' }}>
                                <div style={{ padding: '24px', borderBottom: '1px solid #e5e7eb', flexShrink: 0 }}>
                                    <h5 style={{ fontWeight: '600', margin: 0 }}>Formula List ({records.length} items)</h5>
                                </div>

                                <div className="table-container" style={{ flex: '1', minHeight: 0 }}>
                                    <table className="table table-hover mb-0">
                                        <thead style={{ background: '#f8f9fa' }}>
                                            <tr>
                                                <th style={{ padding: '16px 24px', fontWeight: '600', color: '#374151', border: 'none' }}>Formula ID</th>
                                                <th style={{ padding: '16px 24px', fontWeight: '600', color: '#374151', border: 'none' }}>Assigned To</th>
                                                <th style={{ padding: '16px 24px', fontWeight: '600', color: '#374151', border: 'none' }}>Customer</th>
                                                <th style={{ padding: '16px 24px', fontWeight: '600', color: '#374151', border: 'none' }}>Product Name</th>
                                                <th style={{ padding: '16px 24px', fontWeight: '600', color: '#374151', border: 'none' }}>Form</th>
                                                <th style={{ padding: '16px 24px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center' }}>Status</th>
                                                <th style={{ padding: '16px 24px', fontWeight: '600', color: '#374151', border: 'none' }}>Date Created</th>
                                                <th style={{ padding: '16px 24px', fontWeight: '600', color: '#374151', border: 'none', textAlign: 'center' }}>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="8" className="text-center py-4">
                                                        <div className="d-flex justify-content-center align-items-center" style={{ gap: '10px' }}>
                                                            <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
                                                            <span>Loading formulas...</span>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ) : error ? (
                                                <tr>
                                                    <td colSpan="8" className="text-center py-4 text-danger">
                                                        <i className="ti-alert-circle me-2"></i>
                                                        {error}
                                                    </td>
                                                </tr>
                                            ) : records.length > 0 ? (
                                                records.map((formula, index) => (
                                                    <tr key={index} style={{ borderTop: index > 0 ? '1px solid #f3f4f6' : 'none' }}>
                                                        <td style={{ padding: '16px 24px', border: 'none', fontWeight: '600' }}>
                                                            <a href="#" onClick={(e) => this.openPage(e, formula.id)} style={{ color: '#007bff', textDecoration: 'none' }}>
                                                                {formula.id}
                                                            </a>
                                                        </td>
                                                        <td style={{ padding: '16px 24px', border: 'none' }}>
                                                            <select
                                                                value={formula.assignedTo || ''}
                                                                onChange={(e) => this.handleAssign(formula.id, e.target.value)}
                                                                onClick={(e) => e.stopPropagation()}
                                                                style={{
                                                                    border: '1px solid #dee2e6',
                                                                    borderRadius: '4px',
                                                                    padding: '4px 8px',
                                                                    fontSize: '13px',
                                                                    width: '150px',
                                                                    backgroundColor: 'white'
                                                                }}
                                                            >
                                                                <option value="">Unassigned</option>
                                                                {this.state.assignableUsers.map(u => (
                                                                    <option key={u.id} value={u.id}>{u.fullname}</option>
                                                                ))}
                                                            </select>
                                                        </td>
                                                        <td style={{ padding: '16px 24px', border: 'none' }}>{formula.customer || '-'}</td>
                                                        <td style={{ padding: '16px 24px', border: 'none' }}>{formula.product || '-'}</td>
                                                        <td style={{ padding: '16px 24px', border: 'none' }}>{formula.form || '-'}</td>
                                                        <td style={{ padding: '16px 24px', border: 'none', textAlign: 'center' }}>
                                                            <span className={`badge ${
                                                                formula.status === 'draft' ? 'bg-secondary' :
                                                                formula.status === 'in-process' ? 'bg-info' :
                                                                formula.status === 'archived' ? 'bg-dark' : 'bg-warning'
                                                            }`} style={{ padding: '6px 12px' }}>
                                                                {formula.status}
                                                            </span>
                                                        </td>
                                                        <td style={{ padding: '16px 24px', border: 'none' }}>{formula.dateCreated}</td>
                                                        <td style={{ padding: '16px 24px', border: 'none', textAlign: 'center' }}>
                                                            <Dropdown className="action-dropdown">
                                                                <Dropdown.Toggle
                                                                    as="button"
                                                                    className="btn btn-link text-dark p-0 border-0"
                                                                    id={`dropdown-${formula.id}`}
                                                                    style={{ fontSize: '20px', background: 'none', boxShadow: 'none', cursor: 'pointer', textDecoration: 'none' }}
                                                                >
                                                                    <i className="ti-more"></i>
                                                                </Dropdown.Toggle>
                                                                <Dropdown.Menu align="end" style={{ zIndex: 1060, position: 'absolute' }}>
                                                                    <Dropdown.Item onClick={() => this.handleAction('edit', formula.id)} style={{ padding: '8px 16px' }}>
                                                                        <i className="ti-pencil" style={{ marginRight: '12px', display: 'inline-block' }}></i>
                                                                        <span>Edit</span>
                                                                    </Dropdown.Item>
                                                                    <Dropdown.Item onClick={() => this.handleAction('history', formula.id)} style={{ padding: '8px 16px' }}>
                                                                        <i className="ti-time" style={{ marginRight: '12px', display: 'inline-block' }}></i>
                                                                        <span>History</span>
                                                                    </Dropdown.Item>
                                                                    
                                                                    <Dropdown.Item
                                                                        onClick={() => this.handleAction('submitToDraftQuote', formula.id)}
                                                                        style={{ padding: '8px 16px' }}
                                                                        disabled={this.state.submittingFormulaId === formula.id}
                                                                    >
                                                                        <i className={this.state.submittingFormulaId === formula.id ? "spinner-border spinner-border-sm" : "ti-location-arrow"} style={{ marginRight: '12px', display: 'inline-block' }}></i>
                                                                        <span>{this.state.submittingFormulaId === formula.id ? 'Submitting...' : 'Submit to Estimate'}</span>
                                                                    </Dropdown.Item>
                                                                    
                                                                    {formula.status === 'archived' ? (
                                                                        <Dropdown.Item onClick={() => this.handleAction('unarchive', formula.id)} style={{ padding: '8px 16px' }}>
                                                                            <i className="ti-archive" style={{ marginRight: '12px', display: 'inline-block' }}></i>
                                                                            <span>Unarchive</span>
                                                                        </Dropdown.Item>
                                                                    ) : (
                                                                        <Dropdown.Item onClick={() => this.handleAction('archive', formula.id)} style={{ padding: '8px 16px' }}>
                                                                            <i className="ti-archive" style={{ marginRight: '12px', display: 'inline-block' }}></i>
                                                                            <span>Archive</span>
                                                                        </Dropdown.Item>
                                                                    )}
                                                                    {this.state.isAdmin && (
                                                                        <>
                                                                            <Dropdown.Divider />
                                                                            <Dropdown.Item
                                                                                className="text-danger"
                                                                                onClick={() => this.handleAction('delete', formula.id)}
                                                                                style={{ padding: '8px 16px' }}
                                                                            >
                                                                                <i className="ti-trash" style={{ marginRight: '12px', display: 'inline-block' }}></i>
                                                                                <span>Delete</span>
                                                                            </Dropdown.Item>
                                                                        </>
                                                                    )}
                                                                </Dropdown.Menu>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center py-4 text-muted">
                                                        No formulas found matching your criteria
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Pagination */}
                                {totalItems > perPage && (
                                    <div style={{ padding: '16px 24px', borderTop: '1px solid #e5e7eb', flexShrink: 0 }}>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                                <span>Show</span>
                                                <select
                                                    className="form-select form-select-sm"
                                                    value={perPage}
                                                    onChange={(e) => this.onPerPageChange(e)}
                                                    style={{ width: 'auto' }}
                                                >
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                    <option value="100">100</option>
                                                </select>
                                                <span>entries</span>
                                            </div>
                                            <PaginatedItems
                                                itemsPerPage={perPage}
                                                totalItems={totalItems}
                                                paginate={this.paginatePage}
                                                currentPage={pageNumber}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </section>
                </div>

                {/* Custom Date Range Modal */}
                <Modal show={showCustomDatePicker} onHide={this.handleCustomDateCancel}>
                    <Modal.Header closeButton>
                        <Modal.Title>Select Custom Date Range</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Start Date</label>
                                <DatePicker
                                    selected={customStartDate}
                                    onChange={(date) => this.setState({ customStartDate: date })}
                                    maxDate={customEndDate || new Date()}
                                    className="form-control"
                                    dateFormat="MM/dd/yyyy"
                                    placeholderText="Select start date"
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">End Date</label>
                                <DatePicker
                                    selected={customEndDate}
                                    onChange={(date) => this.setState({ customEndDate: date })}
                                    minDate={customStartDate}
                                    maxDate={new Date()}
                                    className="form-control"
                                    dateFormat="MM/dd/yyyy"
                                    placeholderText="Select end date"
                                />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCustomDateCancel}>
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            onClick={this.handleCustomDateApply}
                            disabled={!customStartDate || !customEndDate}
                        >
                            Apply
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Delete Confirmation Modal */}
                <Modal show={showDeleteModal} onHide={this.handleCloseDeleteModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Delete</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Are you sure you want to delete formula <strong>{deleteFormulaId}</strong>? This action cannot be undone.
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseDeleteModal}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={this.confirmDelete}>
                            Delete
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* History Modal */}
                <Modal show={this.state.showHistoryModal} onHide={this.closeHistoryModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>RFQ History - RFQ-{String(this.state.historyRfqId).padStart(4, '0')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.historyLoading ? (
                            <div className="text-center py-4">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden"></span>
                                </div>
                            </div>
                        ) : this.state.historyData.length === 0 ? (
                            <div className="text-center py-4 text-muted">
                                No history records found
                            </div>
                        ) : (
                            <>
                                <div className="table-responsive">
                                    <table className="table table-hover">
                                        <thead>
                                            <tr>
                                                <th>Updated On</th>
                                                <th>Updated By</th>
                                                <th>Status</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.historyData.map((record) => (
                                                <tr key={record.rfqHistoryId}>
                                                    <td>{new Date(record.updatedOn).toLocaleString()}</td>
                                                    <td>{record.updatedBy}</td>
                                                    <td>
                                                        <span className={`badge ${
                                                            record.status === 'Draft' ? 'bg-secondary' :
                                                            record.status === 'In-Process' ? 'bg-primary' :
                                                            record.status === 'Submitted to Formulation' ? 'bg-success' :
                                                            record.status === 'Archived' ? 'bg-dark' : 'bg-warning'
                                                        }`}>
                                                            {record.status}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <Button
                                                            variant="link"
                                                            size="sm"
                                                            onClick={(e) => this.viewHistoryRecord(e, record)}
                                                        >
                                                            <i className="ti-eye"></i> View
                                                        </Button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>

                                {/* Pagination */}
                                {this.state.historyTotalPages > 1 && (
                                    <div className="d-flex justify-content-center align-items-center mt-3">
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            onClick={() => this.handleHistoryPageChange(this.state.historyPage - 1)}
                                            disabled={this.state.historyPage === 1}
                                            className="me-2"
                                        >
                                            <i className="ti-angle-left"></i> Previous
                                        </Button>
                                        <span className="mx-3">
                                            Page {this.state.historyPage} of {this.state.historyTotalPages}
                                        </span>
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            onClick={() => this.handleHistoryPageChange(this.state.historyPage + 1)}
                                            disabled={this.state.historyPage === this.state.historyTotalPages}
                                            className="ms-2"
                                        >
                                            Next <i className="ti-angle-right"></i>
                                        </Button>
                                    </div>
                                )}
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.closeHistoryModal}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

            </Layout>
        );
    }
}

export default FormulaRepository;